import { call, put } from "typed-redux-saga";
import { ActiveCampaignResponse } from "../../core/api/requests/campaign/active/types";
import { campaignActiveApi } from "../../core/http/httpClient";
import { ApiResponse } from "../../core/types";
import { takeEveryFsa } from "../operations";
import { campaignActions } from "./actions";

export function* campaignSaga() {
  yield takeEveryFsa(
    campaignActions.fetchActiveCampaign.started,
    function* (action) {
      const { onComplete, onError, onSuccess } = action.payload;

      const { response, error }: ApiResponse<ActiveCampaignResponse> =
        yield call(() => {
          return campaignActiveApi
            .call(action.payload)
            .then((response) => ({ response }))
            .catch((error) => ({ error }));
        });

      onComplete?.();

      if (!response || error) return onError?.(error);

      yield* put(
        campaignActions.fetchActiveCampaign.done({
          params: action.payload,
          result: response.data,
        }),
      );

      onSuccess?.(response.data);
    },
  );
}
